<!-- 分成方详情 -->
<template>
  <scroll-layout>
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageButtons"
          :key="button.id || index"
          v-bind="button"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
    </template>
    <div class="content">
      <ykc-detail-plus class="box-card" :labelWidth="120">
        <div slot="header" class="clearfix">
          <span>分成方信息</span>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="分成方编号">
            <span>{{ dealData(formData.partnerNo) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="分成方名称">
            <span>{{ dealData(formData.partnerName) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="分成方类型">
            <span>{{ dealData(formData.partnerTypeName) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="结算周期">
            <span>{{ dealData(formData.settlementCycleName) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="分成方地址">
            <span>{{ dealData(formData.partnerAddress) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="资质名称">
            <span>{{ dealData(formData.aptitudeName) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="联系人姓名">
            <span>{{ dealData(formData.contacts) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="联系人性别">
            <span>{{ dealData(formData.contactsSexName) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="联系人手机号">
            <span>{{ dealData(formData.contactsPhone) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="联系人职务">
            <span>{{ dealData(formData.contactsJob) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="联系人邮箱">
            <span>{{ dealData(formData.contactsEmail) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="联系人电话">
            <span>{{ dealData(formData.contactsTelephone) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="收款单位名称">
            <span>{{ dealData(formData.company) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="收款银行">
            <span>{{ dealData(formData.bank) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="收款账号">
            <span>{{ dealData(formData.bankNo) }}</span>
          </ykc-detail-item-plus>
        </div>
      </ykc-detail-plus>
      <ykc-detail-plus class="box-card" :labelWidth="110">
        <div slot="header" class="clearfix">
          <span>站点信息</span>
        </div>
        <ykc-table
          ref="YkcTable"
          style="box-shadow: none"
          :data="tableData"
          :columns="tableColumns"></ykc-table>
      </ykc-detail-plus>
    </div>
  </scroll-layout>
</template>

<script>
  import { partnerData } from '@/service/apis';
  import { dealData } from '../../../../utils/index';

  export default {
    name: 'PartnerDetail',
    components: {},
    data() {
      return {
        id: '',
        formData: {},
        tableData: [],
        tableColumns: [
          { label: '站点ID', prop: 'stationId', minWidth: '100px' },
          { label: '站点名称', prop: 'stationName', minWidth: '150px' },
          { label: '生效时间', prop: 'beginTime', minWidth: '150px' },
          { label: '失效时间', prop: 'endTime', minWidth: '150px' },
          {
            label: '状态',
            prop: 'deleted',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => (row.deleted === 0 ? '生效中' : '已失效'),
            },
          },
        ],
        pageButtons: [
          {
            id: '0',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
      };
    },
    created() {
      const { id } = this.$route.query;
      this.id = id;
      this.queryDetail();
    },
    methods: {
      dealData,
      queryDetail() {
        if (this.id) {
          partnerData
            .partnerDetail({ id: this.id })
            .then(res => {
              this.formData = res;
              this.tableData = res.stationOfPartnerDTOList;
            })
            .catch(() => {});
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .content {
    display: flex;
    flex: 1;
    flex-direction: column;
    .box-card {
      width: 100%;
      height: auto;
      margin: 10px 0px 0px 0px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      .flexBox {
        display: flex;
        margin-bottom: 20px;
      }
    }
  }
</style>
